import { render, staticRenderFns } from "./InviterOrder.vue?vue&type=template&id=15cb9dc8&scoped=true&"
import script from "./InviterOrder.vue?vue&type=script&lang=js&"
export * from "./InviterOrder.vue?vue&type=script&lang=js&"
import style0 from "./InviterOrder.vue?vue&type=style&index=0&id=15cb9dc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cb9dc8",
  null
  
)

export default component.exports